import SearchResultContainer from "../../Componant/SearchResult";

const SearchResult = () => {
  return (
    <div className="page-body">
      <SearchResultContainer />
    </div>
  );
};

export default SearchResult;
